import { useEffect, useMemo, useState } from 'react';

import useSuspenseQuery from 'commons/useSuspenseQuery';
import formatDuration from 'commons/formatDuration';
import getVideoType from 'commons/getVideoType';
import { GET_VIDEO_METADATA } from 'mocks/queries';

const useVideoMetadata = ({ skip = false, videoId } = {}) => {
  const [durationInSeconds, setDurationInSeconds] = useState(0);
  const [thumbnail, setThumbnail] = useState('');
  const videoType = useMemo(() => getVideoType(videoId), [videoId]);

  const { loading, data = {} } = useSuspenseQuery(GET_VIDEO_METADATA, {
    variables: { id: videoId, type: videoType },
    skip: skip || !videoId,
  });

  const { getVideoMetadata } = data;

  useEffect(() => {
    if (skip || loading || !getVideoMetadata) {
      return;
    }

    if (getVideoMetadata.duration) {
      setDurationInSeconds(getVideoMetadata.duration);
    }

    if (getVideoMetadata.thumbnails.length > 0) {
      const url =
        getVideoMetadata.thumbnails.length > 3
          ? getVideoMetadata.thumbnails[3]
          : getVideoMetadata.thumbnails[0];

      setThumbnail(url);
    }
  }, [getVideoMetadata, loading, skip]);

  const duration = useMemo(() => formatDuration(durationInSeconds), [
    durationInSeconds,
  ]);

  return {
    duration,
    thumbnail,
  };
};

export default useVideoMetadata;
